@if (field.label) {
  <fmnts-label class="form-field__label form-field__label--external">
    {{ field.label | translateInline }}
  </fmnts-label>
}

<fmnts-radio-group
  [(ngModel)]="value"
  class="grid"
  [class.fmnts-radio-group--invalid]="showError"
>
  @for (item of items(); track item) {
    <fmnts-radio-card
      [value]="item.value"
      [class]="item.style || 'w-full md:w-1/2'"
      [attr.data-testid]="'sponsorship-item-' + item.value"
      fmnts-flex
      direction="row"
    >
      <ng-container
        *ngrxLet="{
          description: htmlContentFromField$(item.description),
        } as itemVm"
      >
        <div class="form-field__sponsorship-image">
          <img [src]="item.image_url" alt="sponsorship" />
        </div>
        <div class="form-field__sponsorship-text">
          <h4 class="form-field__sponsorship-label">
            {{ item.label | translateInline }}
          </h4>
          @if (itemVm.description) {
            <div
              class="form-field__sponsorship-description"
              [innerHTML]="itemVm.description"
            ></div>
          }</div
      ></ng-container>
    </fmnts-radio-card>
  }
</fmnts-radio-group>

<div class="form-field__error-message">
  @if (showError && control.errors) {
    <fmnts-form-error>
      {{ control.errors | declarativeErrorMessage: field : declaration }}
    </fmnts-form-error>
  }
</div>
